import { columnHelper } from './helper';

export const type = columnHelper.accessor('Type', {
  header: '类型',
  id: 'type',
  cell: ({ row }) => row.original.Type || '-',
});
